import { take, put } from "redux-saga/effects";

// services
import { getCampusStudents } from "../../../services/http/schools";

// types
import { GetCampusUsersResponseTypes } from "../../actions/schools/types";

import * as Effects from "redux-saga/effects";
import { GET_CAMPUS_STUDENTS, getCampusStudentsActions } from "../../actions/schools";
const call: any = Effects.call;

function* watchGetCampusStudentsRequest() {
  while (true) {
    const { payload }: IActionType<{ campusId: number | undefined }> = yield take(GET_CAMPUS_STUDENTS.REQUEST);

    try {
      const result: GetCampusUsersResponseTypes = yield call(getCampusStudents, payload);
      yield put(getCampusStudentsActions.success(result));
    } catch (e) {
      yield put(getCampusStudentsActions.error(e as any));
    }
  }
}

export default watchGetCampusStudentsRequest;
